import { render, staticRenderFns } from "./JdsField.vue?vue&type=template&id=5d423c12&scoped=true&"
import script from "./JdsField.vue?vue&type=script&lang=ts&"
export * from "./JdsField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d423c12",
  null
  
)

export default component.exports